module.exports = __webpack_public_path__ + "static/img/img_01.3d2e2fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/img_01.png
// module id = F52b
// module chunks = 17